
    <div class="google-map"></div>
    <ng-content></ng-content>
  